import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { Skeleton } from '@shared/components/Skeleton';
import { Box, Flex } from '@withjoy/joykit';
import React from 'react';
import { useCardCategoryContext } from '@apps/card/components/CardCategoryProvider';
import { TileGrid } from '@apps/card/components/TileGrid';
import { GalleryTile } from '@apps/card/components/GalleryTile';
import { PageSection } from '@apps/card/components/PageSection';

export const DesignsGallerySkeleton = () => {
  const { currentCategory } = useCardCategoryContext();

  const isCategoryWithConciergeService = [StationeryTemplateCategoryEnum.invitation, StationeryTemplateCategoryEnum.saveTheDate].includes(currentCategory);

  return (
    <>
      <PageSection
        id="design-gallery-skeleton"
        paddingX={0}
        spacing={{ _: 7, md: 9 }}
        title={() =>
          isCategoryWithConciergeService ? (
            <Box>
              <Skeleton
                width={270}
                height={7}
                marginX={{ _: 6, md: 8 }}
              />
            </Box>
          ) : (
            <Flex
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              rowGap={5}
            >
              <Skeleton
                width={340}
                height={36}
              />
              <Skeleton
                width={400}
                height={18}
              />
              <Skeleton
                width={280}
                height={18}
              />
            </Flex>
          )
        }
      >
        <TileGrid>
          {Array.from({ length: 8 }).map((_, index) => (
            <GalleryTile.Skeleton key={index} />
          ))}
        </TileGrid>
      </PageSection>
    </>
  );
};
